import henryPic from "@/public/images/artists/henry.png";
import { Artist } from "@/types/types";

export const henry = {
  id: "180",
  name: "Henry",
  image: henryPic,
  description: `Henry's voice channels the timeless essence of soul, blending extraordinary control with a natural, free-flowing expressiveness. It's a warm, midrange voice that thrives on simplicity, letting the emotion in each lyric take center stage.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fhenry-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Soul", "Rock", "Blues", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Low",
      },
      specific: {
        low: 51,
        high: 63,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
